/*
 * Copyright (c) to Energy Analytics & Solutions Pty Ltd. All rights reserved.
 */

import { Alert } from "@mui/material";
import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
const ChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const { token } = useParams();
  const [mailerState, setMailerState] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [errorState, setErrorState] = useState({
    errMsg: "",
    severity: "error",
  });
  function handleStateChange(e) {
    setMailerState((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  }
  const submitPass = async (e) => {
    e.preventDefault();
    console.log({ mailerState });
    setLoading(true);
    if (mailerState.newPassword !== mailerState.confirmPassword) {
      setErrorState({
        errMsg: "password and confirm password don't match",
        severity: "warning",
      });
      setLoading(false);
      return;
    }

    await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/user/reset-password/${token}`,
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        // body: JSON.stringify({ mailerState }),
        body: JSON.stringify({ password: mailerState.newPassword }),
      }
    )
      .then((res) => {
        setLoading(false);
        res.json();
        if (res.status === 200) {
          setErrorState({
            errMsg: "Password has been successfully changed!!",
            severity: "success",
          });
          setTimeout(() => {
            window.location = `${process.env.REACT_APP_FRONTEND_URL}`;
            // window.location = "http://localhost:3000";
          }, 2000);
        } else if (res.status === 404) {
          setErrorState({
            errMsg:
              "you are not registered with us Please contact administrator",
            severity: "error",
          });
        } else if (res.status === 400) {
          setErrorState({
            errMsg: "Link expired!!",
            severity: "error",
          });
        } else {
          setErrorState({
            errMsg: "Something went wrong!!",
            severity: "error",
          });
        }
      })
      .then(() => {
        setMailerState({
          newPassword: "",
          confirmPassword: "",
        });
        // alert("Password has been changed!!")
        // window.location = "http://localhost:3001";
      });
  };
  return (
    <>
      <div>
        {errorState.errMsg && (
          <Alert
            onClose={() => {
              setErrorState({
                ...errorState,
                errMsg: "",
              });
            }}
            severity={errorState.severity}
          >
            {errorState.errMsg}
          </Alert>
        )}
      </div>
      <div className="forgotPwdForm">
        <h3>Enter New Password</h3>
        <Form>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>New Password</Form.Label>
            <Form.Control
              onChange={handleStateChange}
              name="newPassword"
              type="password"
              placeholder="Enter New Password"
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control
              onChange={handleStateChange}
              name="confirmPassword"
              type="password"
              placeholder="Enter Confirm New Password"
            />
          </Form.Group>
          <Button
            style={{
              backgroundColor: "#2e3192",
            }}
            onClick={submitPass}
            disabled={
              loading ||
              !mailerState.newPassword ||
              !mailerState.confirmPassword
            }
            type="submit"
          >
            Submit
          </Button>
        </Form>
      </div>
    </>
  );
};

export default ChangePassword;

/*
 * Copyright (c) to Energy Analytics & Solutions Pty Ltd. All rights reserved.
 */
